import { Handle, Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export function EvalNode({ data }: { data: { label: string; alias?: string } }) {
  return (
    <BaseNode
      type="eval"
      label={data.label}
      alias={data.alias}
      hasSource={false}
      footer={
        <div className="flex justify-between px-6 font-medium">
          <span className="text-success">true</span>
          <span className="text-destructive">false</span>
        </div>
      }
    >
      <Handle type="source" position={Position.Bottom} id="true" style={{ left: '28%' }} className="!border-success" />
      <Handle type="source" position={Position.Bottom} id="false" style={{ left: '72%' }} className="!border-destructive" />
    </BaseNode>
  );
}
